// extracted by mini-css-extract-plugin
export default {"action-btn":"HealthDenialTwo--action-btn--5i--N","actionBtn":"HealthDenialTwo--action-btn--5i--N"};